"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PubSubEventTypes;
(function (PubSubEventTypes) {
    PubSubEventTypes["UPDATE_GROUP_EVENT"] = "updateGroup";
    PubSubEventTypes["WILL_UPDATE_GROUP_EVENT"] = "willUpdateGroup";
    PubSubEventTypes["DID_UPDATE_GROUP_EVENT"] = "didUpdateGroup";
    PubSubEventTypes["UPDATE_MEMBERS_EVENT"] = "updateMembers";
    PubSubEventTypes["UPDATE_CONTEXT_TOKENS_EVENT"] = "updateContextTokens";
    PubSubEventTypes["FEED_AUTHORS_IDS"] = "feedAuthorsIds";
})(PubSubEventTypes = exports.PubSubEventTypes || (exports.PubSubEventTypes = {}));
//# sourceMappingURL=PubSubEventTypes.js.map